import { PrivacyTypes, CVPreviewStates, ProfileV2 } from '../../types';

function getCvPreviewStatus(profile: ProfileV2): CVPreviewStates {
  const { hasResume, profilePrivacy } = profile;

  if (!hasResume) {
    return CVPreviewStates.NoCv;
  }

  if (profilePrivacy === PrivacyTypes.Limited) {
    return CVPreviewStates.CvPrivate;
  }

  if (!profile.resumeCoreDataAvailable) {
    return CVPreviewStates.CvNotParsed;
  }

  return CVPreviewStates.CvPreview;
}

export default getCvPreviewStatus;
